// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4739":"a59c2efeeacdaf31","8981":"73e3013964a28adc"}[chunkId] + ".css";
};